import { render, staticRenderFns } from "./DemoOrg.vue?vue&type=template&id=b46aae3e"
import script from "./DemoOrg.vue?vue&type=script&lang=ts"
export * from "./DemoOrg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports